export default {
  discordUrl: 'https://discord.gg/maxquest',
  facebookUrl: 'https://www.facebook.com/maxquestofficial/',
  telegramUrl: 'https://t.me/PlayMaxQuest',
  twitterUrl: 'https://twitter.com/playmaxquest',
  twitchUrl: 'https://www.twitch.tv/playmaxquest',
  tiktokUrl: 'https://www.tiktok.com/@maxquestofficial',
  instagramUrl: 'https://www.instagram.com/maxquestofficial/',
  youtubeUrl: 'https://www.youtube.com/@playmaxquest',
};
